
// This enum is used for any spinner state
export enum RequestState {
  PRISTINE = 'pristine',
  WAITING = 'waiting',
  SUCCESS = 'success',
  FAIL = 'fail'
}
